// extracted by mini-css-extract-plugin
export default {"selectFilter":"Filters_selectFilter__JMhgc"};